<template class="modal-leftovers">
<b-modal id="leftovers-modal" centered :hide-footer="true" :hide-header="true" @hidden="$emit('dismissModal', $event)">
  <template class="modal-leftovers" v-slot:default="{ hide }">
    <p class="modal-title">{{ $t('recipes.lblHowManyExtraServingsDoYouWant') }}</p>

    <div class="serves-select-wrapper">
      <div class="serves-select">
        <span @click="decrementServings">
          <i class="fas fa-minus serves-select-icon" />
        </span>
        <div class="adjust-serves"> {{ this.extraServings }} More </div>
        <span @click="incrementServings">
          <i class="fas fa-plus serves-select-icon" />
        </span>
      </div>
    </div>
  </template>

  <template v-slot:modal-footer="{ ok, hide }">
    <div class="add-leftovers-wrapper">
      <BaseButton type="button" class="btn-secondary btn-block btn-add-leftovers" @click="addLeftovers">
        {{ $t('recipes.lblAddLeftovers') }}
      </BaseButton>
    </div>
    <BaseButton class="btn-clear" @click="hide()">
      {{ $t('lblBack') }}
    </BaseButton>
  </template>
</b-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      extraServings: this.adjustmentDelta,
    };
  },
  props: {
    adjustmentDelta: {
      type: Number,
      required: true,
    },
  },
  computed: {},
  methods: {
    incrementServings() {
      this.extraServings += this.adjustmentDelta;
    },
    decrementServings() {
      if (this.extraServings > this.adjustmentDelta) {
        this.extraServings -= this.adjustmentDelta;
      }
    },
    async hide() {
      await this.$bvModal.hide('leftovers-modal');
      this.extraServings = this.adjustmentDelta;
    },
    addLeftovers() {
      this.$emit('add-leftovers', this.extraServings);
      this.hide();
    },
  },
  watch: {
    adjustmentDelta() {
      this.extraServings = this.adjustmentDelta;
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-body {
  padding: 4.7rem 4.8rem 3.5rem !important;
}

.serves-select-wrapper {
  display: flex;
  flex: 2;
  justify-content: center;
  margin-bottom: 1rem;

  .serves-select {
    align-items: center;
    border: 1px solid $base-border-color;
    border-radius: $base-border-radius;
    display: flex;
    flex: 1;
    font-size: 1.3rem;
    justify-content: space-between;
    padding: 1rem 2rem;

    .adjust-serves {
      font-size: 1.5rem;
      margin-bottom: 0;
    }

    .serves-select-icon {
      color: $color-action;
      font-size: 1.4rem;
    }
  }
}

.modal-title {
  font-size: 1.7rem;
  margin-bottom: 2.4rem;
}

.add-leftovers-wrapper {
  margin-bottom: 2rem;
}

.button.btn-clear.btn-clear {
  border-radius: $base-border-radius;
  color: $color-action !important;
  text-transform: capitalize !important;
}
</style>
